import _get from "lodash/get";
import { AnyAction } from "redux";
import * as ONBOARDING_AT from "./actionTypes";
import { SubscriptionDetailsState } from "../../../../models/state";
import { fulfilled } from "../../app/utils";
import * as AT from "../../checkout/state/actionTypes";

const initialState = (): SubscriptionDetailsState => ({
    id: "",
    selectedPhoneNumber: "",
    isEsimSelected: false,
    check: {
        isAllowedToProceed: false,
    },
    subscription: {},
});

const reducer = (state = initialState(), action: AnyAction): SubscriptionDetailsState => {
    switch (action.type) {
        case ONBOARDING_AT.ONBOARDING_SET_SIM_TYPE:
            return {
                ...state,
                isEsimSelected: action.payload,
            };
        case AT.CHECKOUT_SET_SELECTED_PHONE_NUMBER:
            return {
                ...state,
                selectedPhoneNumber: action.selectedPhoneNumber,
                check: {
                    ...state.check,
                    type: action.customerType,
                    isAllowedToProceed: action.customerType === "new",
                },
            };
        case fulfilled(AT.CHECKOUT_CHECK_NEW_MEMBER_PHONE_NUMBER):
            return {
                ...state,
                accountId: _get(action, "payload.phoneNumberData.accountId"),
                check: {
                    type: _get(action, "payload.phoneNumberData.type"),
                    isAllowedToProceed: !!action.payload.allowedToProceed,
                    isPhoneNumberActive: _get(action, "payload.phoneNumberData.status", "") === "A",
                    isFormerLegalOwnerSameAsBankId: _get(
                        action,
                        "payload.phoneNumberData.isFormerLegalOwnerSameAsBankId",
                    ),
                },
            };
        default:
            return state;
    }
};

export default reducer;
